/* Shared native scroll gallery and close-up viewer for the product page. */
(() => {
  const dialog = document.getElementById('photo-dialog');
  let viewer = null, returnFocus = null, previousOverflow = '';
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  const text = value => String(value).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  function responsive(src) {
    return [400, 800, 1200].map(w => src.replace(/\.jpg$/, '-' + w + '.webp') + ' ' + w + 'w').join(', ');
  }
  function zoom(enabled) {
    const stage = dialog.querySelector('.dialog-image');
    stage.classList.toggle('is-zoomed', enabled);
    const button = document.getElementById('zoom-toggle');
    button.setAttribute('aria-pressed', String(enabled));
    button.textContent = enabled ? 'Fit image −' : 'Zoom in +';
    if (enabled) requestAnimationFrame(() => {
      stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) / 2;
      stage.scrollTop = (stage.scrollHeight - stage.clientHeight) / 2;
    });
    else { stage.scrollLeft = 0; stage.scrollTop = 0; }
  }
  function showLarge(index) {
    viewer.index = (index + viewer.photos.length) % viewer.photos.length;
    const p = viewer.photos[viewer.index];
    const image = document.getElementById('dialog-photo');
    image.src = p.src;
    image.alt = p.alt || p.label;
    document.getElementById('dialog-caption').textContent = (viewer.photos.length > 1 ? p.id + ' · ' : '') + p.label;
    dialog.querySelectorAll('[data-zoom-step]').forEach(b => b.hidden = viewer.photos.length < 2);
    zoom(false);
  }
  function open(photos, index, trigger, slug = 'photograph') {
    if (!dialog) return;
    viewer = { photos, index, slug };
    returnFocus = trigger;
    previousOverflow = document.body.style.overflow;
    showLarge(index);
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    document.getElementById('zoom-close').focus();
  }
  if (dialog) {
    document.getElementById('zoom-close').addEventListener('click', () => dialog.close());
    document.getElementById('zoom-toggle').addEventListener('click', () => zoom(!dialog.querySelector('.dialog-image').classList.contains('is-zoomed')));
    dialog.querySelectorAll('[data-zoom-step]').forEach(b => b.addEventListener('click', () => showLarge(viewer.index + Number(b.dataset.zoomStep))));
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      zoom(false);
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', e => {
      const r = dialog.getBoundingClientRect();
      if (e.target === dialog && (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom)) dialog.close();
    });
    dialog.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault();
        showLarge(viewer.index + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    const stage = dialog.querySelector('.dialog-image');
    stage.addEventListener('dblclick', () => zoom(!stage.classList.contains('is-zoomed')));
    let drag = null;
    stage.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' || !stage.classList.contains('is-zoomed')) return;
      drag = { x: e.clientX, y: e.clientY, left: stage.scrollLeft, top: stage.scrollTop };
      stage.setPointerCapture(e.pointerId);
      stage.classList.add('is-dragging');
      e.preventDefault();
    });
    stage.addEventListener('pointermove', e => {
      if (!drag) return;
      stage.scrollLeft = drag.left + drag.x - e.clientX;
      stage.scrollTop = drag.top + drag.y - e.clientY;
    });
    const end = () => { drag = null; stage.classList.remove('is-dragging'); };
    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
    document.querySelectorAll('[data-original]').forEach(a => a.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      open([{ id: '01', src: a.href, label: a.querySelector('h3').textContent, alt: a.querySelector('img').alt }], 0, a, 'catalogue');
    }));
  }
  function markup(photos) {
    return '<div class="gallery-track" tabindex="0" role="region" aria-roledescription="carousel" aria-label="Hamper photographs">' + photos.map((p, i) => '<div class="gallery-slide" data-slide="' + p.id + '"><button class="gallery-main" type="button" aria-label="Enlarge ' + text(p.label) + '"><img src="' + p.src + '" srcset="' + responsive(p.src) + '" sizes="(max-width:600px) calc(100vw - 36px), 440px" width="1254" height="1254" loading="' + (i ? 'lazy' : 'eager') + '" alt="' + text(p.alt) + '"><span class="zoom-hint" aria-hidden="true">↗</span></button></div>').join('') + '</div><div class="gallery-caption"><p data-photo-caption aria-live="polite"></p><div class="gallery-arrows"><button type="button" data-step="-1" aria-label="Previous photograph">←</button><button type="button" data-step="1" aria-label="Next photograph">→</button></div></div><div class="gallery-thumbs">' + photos.map(p => '<a class="gallery-thumb" href="' + p.src + '" data-photo="' + p.id + '" aria-label="View ' + text(p.label) + '"><img src="' + p.src.replace('.jpg', '-thumb.jpg') + '" width="320" height="320" alt=""><span>' + p.id + '</span></a>').join('') + '</div>';
  }
  function wire(root, photos, options = {}) {
    const track = root.querySelector('.gallery-track');
    const slides = [...root.querySelectorAll('.gallery-slide')];
    const thumbs = [...root.querySelectorAll('.gallery-thumb')];
    const caption = root.querySelector('#photo-caption,[data-photo-caption]');
    let current = 0, timer, disposed = false;
    function paint() {
      thumbs.forEach((t, i) => t.setAttribute('aria-current', String(i === current)));
      const p = photos[current];
      caption.replaceChildren(document.createTextNode(p.id + ' / ' + String(photos.length).padStart(2, '0') + ' '));
      const label = document.createElement('span');
      label.textContent = '— ' + p.label;
      caption.append(label);
      if (options.product) {
        slides.forEach((s, i) => {
          const img = s.querySelector('img'), button = s.querySelector('button');
          if (i === current) { img.id = 'main-photo'; button.id = 'zoom-open'; }
          else { img.removeAttribute('id'); button.removeAttribute('id'); }
        });
      }
      track.dataset.current = p.id;
    }
    function go(index, smooth = true, hash = true) {
      if (disposed) return;
      current = (index + photos.length) % photos.length;
      paint();
      if (!smooth) track.style.scrollBehavior = 'auto';
      track.scrollTo({ left: slides[current].offsetLeft - slides[0].offsetLeft, behavior: smooth ? motion() : 'auto' });
      if (!smooth) requestAnimationFrame(() => track.style.removeProperty('scroll-behavior'));
      if (hash && options.product) history.replaceState(null, '', '#photo=' + photos[current].id);
    }
    thumbs.forEach((a, i) => a.addEventListener('click', e => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault(); go(i);
    }));
    root.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => go(current + Number(b.dataset.step))));
    slides.forEach((slide, i) => slide.querySelector('button').addEventListener('click', e => open(photos, i, e.currentTarget, options.slug)));
    track.addEventListener('scroll', () => {
      if (disposed) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        if (disposed) return;
        const step = slides[1] ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
        // Closing a native dialog can emit a final scroll with zero-sized
        // slides. Keep the selected photograph and ignore that hidden state.
        if (step <= 0) return;
        const next = Math.max(0, Math.min(photos.length - 1, Math.round(track.scrollLeft / step)));
        if (next !== current) {
          current = next; paint();
          if (options.product) history.replaceState(null, '', '#photo=' + photos[current].id);
        }
      }, 90);
    }, { passive: true });
    root.addEventListener('keydown', e => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target.closest('input,textarea,select')) return;
      e.preventDefault(); go(current + (e.key === 'ArrowRight' ? 1 : -1));
    });
    const requested = options.product ? new URLSearchParams(location.hash.slice(1)).get('photo') : null;
    current = Math.max(0, photos.findIndex(p => p.id === requested));
    paint();
    requestAnimationFrame(() => go(current, false, false));
    const observer = new ResizeObserver(() => go(current, false, false));
    observer.observe(track);
    return () => { disposed = true; observer.disconnect(); clearTimeout(timer); };
  }
  window.DeliGallery = { wire, markup, open };
  if (window.DELI_PRODUCT && document.querySelector('.concept-gallery')) {
    wire(document.querySelector('.concept-gallery'), window.CONCEPT_PHOTOS, { ...window.DELI_PRODUCT, product: true });
  }
})();
